import React from "react";
import Header from "./header";
import { Outlet } from "react-router-dom";
import Sidebar from "./sidebar";

const LayoutHeader: React.FunctionComponent<{}> = (props) => {

    return (
        <>
            <div className="layout-wrapper layout-content-navbar">
                <div className="layout-container back-FFFFFF">
                    <div className="display-none-web">
                        <Sidebar />
                    </div>
                    <div className="layout-page-v2">
                        <Header background={"back-header"} />
                        <div className="container-p-y">
                            <Outlet />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LayoutHeader